import { render } from "./StaffFAQ.vue?vue&type=template&id=442cf630&scoped=true"
import script from "./StaffFAQ.vue?vue&type=script&lang=js"
export * from "./StaffFAQ.vue?vue&type=script&lang=js"

import "./StaffFAQ.vue?vue&type=style&index=0&id=442cf630&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442cf630"]])

export default __exports__